import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from "react-bootstrap";
import './i18n';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

document.getElementsByTagName('html')[0].setAttribute('dir',"rtl");

root.render(
  <ThemeProvider dir="rtl">
      <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
